export default __webpack_public_path__ + "static/media/7C4_Kathy Marianito in traditional garb.7faa850c.png";